'use client';

import { Suspense } from 'react';

import { OrderDetail } from '@eliadmin/core/src/components/nt/account/orders/order-detail';
import { OrdersList } from '@eliadmin/core/src/components/nt/account/orders/orders-list';
import { useOrderParam } from '@eliadmin/core/src/components/nt/account/shell/account-pages';

function OrdersRoute() {
  const identifier = useOrderParam();
  return identifier ? <OrderDetail key={identifier} identifier={identifier} /> : <OrdersList />;
}

/**
 * „Moje objednávky“ (Figma 207:11671) or, with `?objednavka=<číslo>`, the order detail (Figma
 * 208:12024) inside the account shell. The root is the size container: the cards follow the width
 * of the account column (990 px beside the sidebar at 1728, the full width on phones), type and
 * spacing tokens the viewport like everywhere else.
 */
export function OrdersView() {
  return (
    <div className="@container">
      <Suspense>
        <OrdersRoute />
      </Suspense>
    </div>
  );
}
